<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="name">
        <el-input v-model="queryParams.name" placeholder="任务名称"  @keyup.enter.native="search" clearable ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        <el-button type="primary" icon="el-icon-upload" @click="handleImport" class="button-class" v-hasPermi="['agent:orientation:import']">导入</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" border>
      <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
      <el-table-column prop="name" label="任务名称" align="center" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="description" label="描述"  align="center"></el-table-column>

      <el-table-column prop="taskKey" label="任务键值" align="center"></el-table-column>
      <el-table-column prop="success" label="成功数" align="center" min-width="120" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="total" label="总数" align="center" min-width="160" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="status" label="状态" align="center" :show-overflow-tooltip="true">
        <template slot-scope="{row}">
          <el-tag type="danger" v-if="row.status =='0'">停用</el-tag>
          <el-tag type="info" v-else-if="row.status == '1'">运行中</el-tag>
          <el-tag type="success" v-else>完成</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="160" align="center" fixed="right">
        <template slot-scope="{row}">
          <el-button type="text" size="mini" @click="start(row)">开启</el-button>
          <el-button type="text" size="mini" @click="stop(row)">停用</el-button>
        </template>
      </el-table-column>
      
    </el-table>
    <!-- 导入对话框 -->
    <el-dialog :title="upload.title" :visible.sync="upload.open" width="400px" @close="dialogClose" append-to-body :close-on-click-modal="false">
      <el-upload
        ref="upload"
        :limit="1"
        accept=".xlsx, .xls"
        :headers="upload.headers"
        :action="upload.url"
        :disabled="upload.isUploading"
        :on-progress="handleFileUploadProgress"
        :on-success="handleFileSuccess"
        :auto-upload="false"
        drag
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip text-center" style="text-align: center;" slot="tip">
          <span>仅允许导入xls、xlsx格式文件。</span>
        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitFileForm">确 定</el-button>
        <el-button @click="upload.open = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { taskList , taskStart , taskStop } from "@/api/api.js";
import { getToken } from '@/utils/auth'
export default {
  name: "task",
  data() {
    return{
      queryParams:{
        name:undefined,
      },
      tableData:[],
      dateRange:[],
      page: 1,
      pageSize: 20,
      total:0,
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: "",
        // 是否禁用上传
        isUploading: false,
        // 设置上传的请求头部
        headers: { Authorization: getToken()},
        // 上传的地址
        url: "/cms/task/flow/import",
      },
    }
  },
  methods: {
    // 获取列表的数据
    initData(){
      taskList().then(res=>{
        this.tableData = res.data.data;
      })
    },
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    // 重置
    resetQuery() {
      this.dateRange = [];
      this.resetForm("queryForm");
      this.search();
    },
    handleImport() {
      this.upload.title = "运营商流量导入";
      this.upload.open = true;
    },
    // 文件上传中处理
    handleFileUploadProgress(event, file, fileList) {
      this.upload.isUploading = true;
    },
    // 文件上传成功处理
    handleFileSuccess(response, file, fileList) {
      this.upload.open = false;
      this.upload.isUploading = false;
      this.$refs.upload.clearFiles();
      this.search();
    },
    // 提交上传文件
    submitFileForm() {
      this.$refs.upload.submit();
    },
    // 关闭弹窗
    dialogClose(){
      this.dialog = false;
      this.initData();
    },
    // 开启任务
    start(row){
      taskStart({id:row.id}).then(res=>{
        if(res.data.code == 200){
          this.$message({
            message: '开启成功',
            type: 'success'
          });
          this.initData();
        }
      })
    },
    // 停用任务
    stop(row){
      taskStop({id:row.id}).then(res=>{
        if(res.data.code == 200){
          this.$message({
            message: '停用成功',
            type: 'success'
          });
          this.initData();
        }
      })
    }
  },
  created() {
    this.initData();
  }
};
</script>
<style scoped lang="less">
  
</style>


